import { FC } from 'react';
import {
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  Button,
} from '@chakra-ui/react';

export interface PlaylistAudioNoteDialogProps {
  open: boolean;
  onClose: () => void;
  message?: string;
  title?: string;
}

export const PlaylistAudioNoteDialog: FC<PlaylistAudioNoteDialogProps> = ({
  open,
  onClose,
  message,
  title,
}) => (
  <Modal isOpen={open} onClose={onClose} data-testid="dialog" size="md">
    <ModalOverlay />
    <ModalContent>
      <ModalHeader data-testid="dialog-title" title={title}>
        {title}
      </ModalHeader>
      <ModalBody
        data-testid="dialog-content"
        maxHeight="300px"
        overflowY="auto"
      >
        <Text fontSize="md" wordBreak="break-word" whiteSpace="pre-wrap">
          {message}
        </Text>
      </ModalBody>
      <ModalFooter data-testid="dialog-actions">
        <Button onClick={onClose}>Done</Button>
      </ModalFooter>
    </ModalContent>
  </Modal>
);
